import React, { useMemo } from 'react';
import classNames from 'classnames';
import style from './index.module.scss';
import Item from './jenga-item';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_ITEMS = 3;
var Count;

(function (Count) {
  Count[Count["One"] = 1] = "One";
  Count[Count["Two"] = 2] = "Two";
  Count[Count["Three"] = 3] = "Three";
  Count[Count["Four"] = 4] = "Four";
})(Count || (Count = {}));

const Jenga = _ref => {
  let {
    entries
  } = _ref;
  const containers = useMemo(() => {
    const items = entries.slice(0, MAX_ITEMS);

    switch (items.length) {
      default:
        return [];

      case Count.One:
        return [['top-left', [{
          image: items[0].image
        }]], ['top-right', [{
          title: items[0].title,
          body: items[0].body
        }]]];

      case Count.Two:
        return [['top-left', [items[0]]], ['top-right', [items[1]]]];

      case Count.Three:
        return [['top-left', [items[0]]], ['top-right', [items[1]]], ['bottom', [items[2]]]];

      case Count.Four:
        return [['top-left', [items[0], items[2]]], ['top-right', [items[1], items[3]]]];
    }
  }, [entries]);
  return /*#__PURE__*/_jsx("div", {
    className: classNames(style.jenga),
    "data-id": "jenga_index_Jenga_div",
    children: containers.map(_ref2 => {
      let [name, container] = _ref2;
      return /*#__PURE__*/_jsx("div", {
        className: classNames(style.container, style[name]),
        "data-id": "jenga_index_Jenga_div_1",
        children: container.map(_ref3 => {
          let {
            id,
            image,
            title,
            body
          } = _ref3;
          return /*#__PURE__*/_jsx(Item, {
            className: classNames(style.item),
            image: image,
            title: title,
            body: body,
            "data-id": "jenga_index_Jenga_Item"
          }, id);
        })
      }, name);
    })
  });
};

export default Jenga;